/**
 * @file: VehicleServiceSubjectTag.ts
 * @author: eric <developer@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum VehicleServiceSubjectTag {
  None = 0,
}

export const VehicleServiceSubjectTagValueSet = new Set([
  VehicleServiceSubjectTag.None,
]);
